import React, { Component } from 'react';

export class RepickPutaway extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        var repicks = this.props.repicks;
        var repickToPutAway = repicks[0];
        var putawayDone = repicks.length == 0;
        return (
            <div className="repickPutaway">
                {
                    !putawayDone
                     &&
                    <form className="slotInput" onSubmit={(e) => this.props.assignRepickToSlot(e)} >
                        <label htmlFor="slotNum"></label>
                        <h1>Repick Putaway</h1>
                        <h3>{repickToPutAway.slot}: {repickToPutAway.tote}{repickToPutAway.priorityRank}</h3>
                        <input
                            autoFocus
                            required
                            pattern='.*'
                            autoComplete="off"
                            type="text"
                            id="repickSlotNum"
                            name="repickSlotNum"
                        />
                    </form>
                }
                {putawayDone && <h1>All Repicks have been put away</h1>}
                <div className="repickPutawayButtons">
                    {this.props.completedRepicks.length > 0 && <button onClick={this.props.repickPutawayBack}>Back</button>}
                    {putawayDone && <button onClick={this.props.endSessionSummary}>Done</button>}
                </div>
            </div>
        );
    }
}
